import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-gray-200 p-2 text-xs gray-700 whitespace-pre-wrap"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.footerDescription)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.footerDescription), 1))
    : _createCommentVNode("", true)
}